/** M-WF-01 · Sequenza dei dipendenti del mese per Compila Orari (usa Foundation Sequence). */
import { useCallback, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { sequenceState, rememberLastSubject } from "@/foundation/sequence";

export const TIMESHEET_WORKFLOW = "timesheet.monthly";
const pad = (n) => String(n).padStart(2, "0");

export function useTimesheetSequence({ employees, employeeId, year, month, companyId }) {
  const [statuses, setStatuses] = useState({});
  const start = `${year}-${pad(month)}-01`;
  const end = `${year}-${pad(month)}-${pad(new Date(year, month, 0).getDate())}`;
  const subjects = useMemo(() => employees.filter((e) => (!e.hire_date || e.hire_date <= end) && (!e.cessation_date || e.cessation_date >= start)), [employees, start, end]);

  const refresh = useCallback(() => api.get("/timesheet/progress", { params: { year, month, ...(companyId ? { company_id: companyId } : {}) } })
    .then(({ data }) => setStatuses(data.items)).catch(() => {}), [year, month, companyId]);
  useEffect(() => { refresh(); }, [refresh]);
  useEffect(() => { if (employeeId) rememberLastSubject(TIMESHEET_WORKFLOW, companyId, employeeId); }, [employeeId, companyId]);

  const state = useMemo(() => sequenceState(subjects, statuses, employeeId), [subjects, statuses, employeeId]);
  const neighbour = (delta) => subjects[state.index + delta];
  return { state, statuses, refresh, neighbour };
}

export default useTimesheetSequence;
